export default __webpack_public_path__ + "static/media/resultsIcon.9b3fa0de.svg";